import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import DataTable from '../../components/ui/data-table';
import EmptyState from '../../components/ui/empty-state.jsx';
import LoadingSpinner from '../../components/common/LoadingSpinner.jsx';
import { academicService } from '../../services/academicService';
import { BookOpen } from 'lucide-react';

const ClassesPage = () => {
  const [classes, setClasses] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const fetchClasses = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await academicService.getMyClasses();
      setClasses(res.data.data || []);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load classes');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchClasses();
  }, []);

  const columns = [
    { id: 'name', header: 'Class', accessorKey: 'name', sortable: true },
    { id: 'description', header: 'Description', accessorKey: 'description' },
    { id: 'academicYear', header: 'Academic Year', accessorKey: 'academicYear', sortable: true },
    { id: 'capacity', header: 'Capacity', accessorKey: 'capacity' },
  ];

  if (loading) return <LoadingSpinner />;
  if (error) return (
    <div className="p-6">
      <Card>
        <CardContent className="p-6">
          <p className="text-red-600 text-sm">{String(error)}</p>
          <Button className="mt-3" onClick={fetchClasses}>Retry</Button>
        </CardContent>
      </Card>
    </div>
  );

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">My Classes</h2>
      {(!classes || classes.length === 0) ? (
        <EmptyState 
          icon={BookOpen}
          title="No classes found"
          description="You are not enrolled/assigned to any class yet."
          action
          actionLabel="Refresh"
          onAction={fetchClasses}
        />
      ) : (
        <Card>
          <CardContent className="p-0">
            <DataTable data={classes} columns={columns} searchable />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default ClassesPage;


